import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { OutlineBtnLoadingComponent } from './outline-btn-loading/outline-btn-loading.component';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { NoDataComponent } from './no-data.component';
import { FullLoaderComponent } from './full-loader.component';
import { Error404Component } from './error-404.component';
import { Error500Component } from './error-500.component';
import { NotFoundComponent } from './not-found.component';
import { RouterModule } from '@angular/router';
import { HoverClassDirective } from '@fuse/directives/hover-class.directive';
import { OnlyNumberDirective } from '@fuse/directives/only-number.directive';
import { TwoDigitDecimaNumberDirective } from '@fuse/directives/decimal-input.directive';
import { InputRegexDirective } from '@fuse/directives/input-regex.directive';
import { ellipsisTooltipDirective } from '@fuse/directives/ellipsis-tooltip.directive';
import { AutofocusDirective } from '@fuse/directives/autofocus.directive';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { ImportCsvComponent } from './import-csv/import-csv.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TruncateTooltipDirective } from 'app/core/directive/truncate-tooltip.directive';
import { AllPipeModule } from 'app/core/pipes/all-pipe.module';
import { GuideVideoComponent } from './guide-video/guide-video.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PauseDialogComponent } from './pause-dialog/pause-dialog.component';
import { ResumeCampaignDialogComponent } from './resume-campaign-dialog/resume-campaign-dialog.component';
import { LoaderComponent } from './loader.component';
import { ProspectUploadMultiwayComponent } from './prospect-upload-multiway/prospect-upload-multiway.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatSelectModule } from '@angular/material/select';
import { CustomFieldComponent } from './custom-field/custom-field.component';
import { AddProspectStatusComponent } from './add-prospect-status/add-prospect-status.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { UpdateCampaignNameComponent } from './update-campaign-name/update-campaign-name.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomTooltipDirective } from '@fuse/directives/custom-tooltip.directive';
import { SpintaxDialogComponent } from './spintax-dialog/spintax-dialog.component';

@NgModule({
    declarations: [
        BtnLoadingComponent,
        DeleteDialogComponent,
        OutlineBtnLoadingComponent,
        NoDataComponent,
        FullLoaderComponent,
        Error404Component,
        Error500Component,
        NotFoundComponent,
        HoverClassDirective,
        OnlyNumberDirective,
        TwoDigitDecimaNumberDirective,
        InputRegexDirective,
        ellipsisTooltipDirective,
        AutofocusDirective,
        ImportCsvComponent,
        TruncateTooltipDirective,
        GuideVideoComponent,
        UploadFileComponent,
        PauseDialogComponent,
        ResumeCampaignDialogComponent,
        LoaderComponent,
        ProspectUploadMultiwayComponent,
        CustomFieldComponent,
        AddProspectStatusComponent,
        UpdateCampaignNameComponent,
        CustomTooltipDirective,
        SpintaxDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        TranslateModule,
        TooltipModule.forRoot({
            hideDelay: 0
        }),
        MatIconModule,
        MatDialogModule,
        MatRippleModule,
        RouterModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        MatMenuModule,
        NgxSkeletonLoaderModule,
        NgSelectModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        AllPipeModule,
        MatAutocompleteModule,
        Ng2SearchPipeModule,
        MatProgressBarModule,
        NgxDropzoneModule,
        MatSelectModule,
        ColorPickerModule,
        NgxMatSelectSearchModule,
        MatOptionModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BtnLoadingComponent,
        TranslateModule,
        TooltipModule,
        DeleteDialogComponent,
        OutlineBtnLoadingComponent,
        MatIconModule,
        NoDataComponent,
        FullLoaderComponent,
        Error404Component,
        Error500Component,
        NotFoundComponent,
        HoverClassDirective,
        OnlyNumberDirective,
        TwoDigitDecimaNumberDirective,
        InputRegexDirective,
        ellipsisTooltipDirective,
        AutofocusDirective,
        ImportCsvComponent,
        TruncateTooltipDirective,
        GuideVideoComponent,
        UploadFileComponent,
        PauseDialogComponent,
        ResumeCampaignDialogComponent,
        LoaderComponent,
        ProspectUploadMultiwayComponent,
        CustomFieldComponent,
        AddProspectStatusComponent,
        UpdateCampaignNameComponent,
        CustomTooltipDirective,
        SpintaxDialogComponent
    ]
})
export class SharedModule
{
}
